export const getYearsTaughtBadge = (years = []) => {
  const normalizedYears = Array.isArray(years)
    ? years.map((year) => String(year || "").trim()).filter(Boolean)
    : [];

  if (!normalizedYears.length) {
    return "";
  }

  const numericYears = Array.from(
    new Set(
      normalizedYears
        .map((year) => {
          const matchedYear = year.match(/year\s*(\d+)/i);
          return matchedYear ? Number(matchedYear[1]) : null;
        })
        .filter((year) => Number.isFinite(year))
    )
  ).sort((firstYear, secondYear) => firstYear - secondYear);

  if (numericYears.length === 1 && normalizedYears.length === 1) {
    return `Year ${numericYears[0]}`;
  }

  if (numericYears.length === normalizedYears.length && numericYears.length > 1) {
    return `Year ${numericYears[0]} to ${numericYears[numericYears.length - 1]}`;
  }

  return normalizedYears.join(", ");
};
